import { render, staticRenderFns } from "./BillingInfEdit-practioner.vue?vue&type=template&id=0bcd47ca&scoped=true"
import script from "./BillingInfEdit-practioner.vue?vue&type=script&lang=js"
export * from "./BillingInfEdit-practioner.vue?vue&type=script&lang=js"
import style0 from "./BillingInfEdit-practioner.vue?vue&type=style&index=0&id=0bcd47ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcd47ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VContainer,VForm,VTextField})
